import { HttpResponse } from '@angular/common/http';

const DEFAULT_EXPORT_CONTENT_TYPE = 'text/csv;charset=UTF-8';

export function downloadBlob(blob: Blob, fileName: string, contentType?: string | null, openInNewTab = false): void {
    const fileBlob = contentType ? new Blob([blob], { type: contentType }) : blob;
    const url = URL.createObjectURL(fileBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    if (openInNewTab) {
        link.target = '_blank';
    }
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}

export function downloadHttpExportResponse(
    response: HttpResponse<Blob | string> | null | undefined,
    fallbackFileName: string,
    defaultContentType: string = DEFAULT_EXPORT_CONTENT_TYPE
): void {
    if (!response?.body) {
        return;
    }

    const fileName = response.headers.get('filename') ?? fallbackFileName;
    const contentType = response.headers.get('content-type') ?? defaultContentType;
    const body = response.body;

    if (typeof body === 'string') {
        downloadBlob(new Blob([body], { type: contentType }), fileName);
        return;
    }

    downloadBlob(body, fileName, contentType);
}
